/**
 * Global request deduplication utility to prevent multiple simultaneous calls to the same endpoint
 */
class RequestDeduplication {
  private activeRequests = new Map<string, Promise<any>>();

  async deduplicate<T>(key: string, requestFn: () => Promise<T>): Promise<T> {
    // If there's already an active request for this key, return the existing promise
    if (this.activeRequests.has(key)) {
      return this.activeRequests.get(key) as Promise<T>;
    }

    // Create new request and store it
    const requestPromise = requestFn().finally(() => {
      // Only clean up when this specific promise completes
      this.activeRequests.delete(key);
    });

    this.activeRequests.set(key, requestPromise);

    return await requestPromise;
  }
}

// Export a singleton instance
export const requestDeduplication = new RequestDeduplication();
